import { PANDADOC_CLIENT_ID, PANDADOC_SECRET, PANDADOC_REDIRECT_URL } from 'environment';

export default function PandadocService($window, $modal, $http, $q) {

  this.tokenFromCode = function(code) {
    return $http.post('https://api.pandadoc.com/oauth2/access_token', $.param({
      grant_type: 'authorization_code',
      client_id: PANDADOC_CLIENT_ID,
      client_secret: PANDADOC_SECRET,
      code: code,
      scope: 'read+write',
      redirect_uri: PANDADOC_REDIRECT_URL,
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
      }
    }).then((resp) => {
      return resp.data;
    });
  };

  this.storeToken = function(data) {
    localStorage.setItem('pandadocAccessToken', data.access_token);
    localStorage.setItem('pandadocRefreshToken', data.refresh_token);
    localStorage.setItem('pandadocTokenExpires', Date.now() + data.expires_in);
  };

  this.authURL = 'https://app.pandadoc.com/oauth2/authorize?' + $.param({
    client_id: PANDADOC_CLIENT_ID,
    redirect_uri: PANDADOC_REDIRECT_URL,
    scope: 'read+write',
    response_type: 'code',
  });

  this.getUserAccessToken = function() {
    // Prefer cached version (refreshing token as necessary)
    let accessToken = localStorage.getItem('pandadocAccessToken');
    let refreshToken = localStorage.getItem('pandadocRefreshToken');
    let tokenExpires = localStorage.getItem('pandadocTokenExpires');
    sessionStorage.setItem("accountRedirect", window.location.pathname);

    if (accessToken && refreshToken && tokenExpires) {
      const padding = 1000 * 60 * 30; // 30 min padding before expiration
      if (tokenExpires > (Date.now() + padding)) {
        return $q((resolve, reject) => resolve(accessToken));
      } else {
        return this.refreshToken(refreshToken).then((result) => {
          this.storeToken(result);
          return result.access_token;
        });
      }
    }
    return $q((resolve, reject) => reject());
  };

  this.refreshToken = function(refreshToken) {
    return $http.post('https://api.pandadoc.com/oauth2/access_token', $.param({
      grant_type: 'refresh_token',
      client_id: PANDADOC_CLIENT_ID,
      client_secret: PANDADOC_SECRET,
      refresh_token: refreshToken,
      scope: 'read+write',
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
      }
    }).then((resp) => {
      return resp.data;
    });
  };

}



// WEBPACK FOOTER //
// ./views/pandadoc/pandadoc_service.js